import React from 'react';

import { useChildComponent } from '@gogame/hooks-ts';
import DataGrid from '@gogame/data-grid';
import {
  useScreenDispatch,
  useScreenState,
  useScreenTitle,
} from '@gogame/screens';

import {
  CreateLabelForm,
  EditLabelForm,
} from 'scenes/Labels/components/LabelForm';
import {
  COLUMN_NAME,
  COLUMN_CREATED_BY,
  COLUMN_CREATED_DATE,
  COLUMN_ID,
  COLUMN_COLOR,
} from 'scenes/Labels/constants';
import { useLoadLabels } from 'scenes/Labels/data';
import {
  COLLAPSE_COLUMNS,
  REORDER_COLUMNS,
  SET_TABLE_SETTINGS,
} from 'scenes/Labels/screenReducer';

import { ColorPreview } from 'scenes/Labels/components/ColorPreview';
import LabelActions from '../Actions';
import Toolbar from './Toolbar';

export const columnMenuConfig = {
  columnMenuCollapsingItem: true,
  columnMenuColorScaleItem: true,
};
const LabelsDataTable = () => {
  const [childComponent, openChildComponent] = useChildComponent();
  const [screenTitle] = useScreenTitle();

  const dispatch = useScreenDispatch();
  const screenState = useScreenState();

  const { data, isLoading, isRefetching } = useLoadLabels(screenState);

  const handleChangeSettings = (settings) => {
    dispatch({
      type: SET_TABLE_SETTINGS,
      payload: settings,
    });
  };

  const handleReorder = (order) => {
    dispatch({
      type: REORDER_COLUMNS,
      payload: order,
    });
  };

  const handleCollapse = (collapsed) => {
    dispatch({
      type: COLLAPSE_COLUMNS,
      payload: collapsed,
    });
  };

  const handleEdit = ({ id }) => {
    openChildComponent(EditLabelForm, { id });
  };

  const handleCreate = () => {
    openChildComponent(CreateLabelForm);
  };

  return (
    <React.Fragment>
      <DataGrid
        rows={data?.rows}
        count={data?.count}
        title={screenTitle}
        loading={isLoading}
        fetching={isRefetching}
        ready={true}
        onChangeSettings={handleChangeSettings}
        onReorder={handleReorder}
        onCollapse={handleCollapse}
        tableSettings={screenState.tableSettings}
        columnsState={screenState.columns}
        columnMenuConfig={columnMenuConfig}
        toolbar={<Toolbar onCreate={handleCreate} />}
        storageKey={'labels'}
        defaultColumnWidth={120}
        filtered={!!screenState.searchQuery}
      >
        <DataGrid.Column
          field={COLUMN_ID}
          type={'text'}
          align={'right'}
          headerAlign={'right'}
          headerName={'ID'}
          width={80}
        />
        <DataGrid.Column
          field={COLUMN_COLOR}
          headerName={'Color'}
          width={74}
          align={'center'}
          sortable={false}
          formatter={(v) => <ColorPreview value={v} />}
        />
        <DataGrid.Column
          field={COLUMN_NAME}
          type={'text'}
          headerName={'Name'}
          width={700}
          flex={3}
        />

        <DataGrid.Column
          field={COLUMN_CREATED_BY}
          headerName={'Created by'}
          width={150}
          type={'text'}
          flex={1}
        />
        <DataGrid.Column
          field={COLUMN_CREATED_DATE}
          headerName={'Created'}
          width={135}
          flex={1}
          type={'date'}
          template={'LLL'}
        />
        <DataGrid.Column
          actionsColDef
          type={'actions'}
          actionsComponent={LabelActions}
          onEdit={handleEdit}
          limit={2}
        />
      </DataGrid>
      {childComponent}
    </React.Fragment>
  );
};

export default LabelsDataTable;
